import React, { useState } from 'react';
import Dropdown from './dropdown';
import BuyModal from './buyModal';
import herbalPdf from '../assets/herbalCatalog.pdf'
import spicesDehydratedPdf from '../assets/spicesAndDehydratedCatalog.pdf'

function ProductsSection({ products, onContactUs }) {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <>
      <div className="free-sample-top">
        <button
          className="free-sample-btn"
          onClick={() => {
            const phoneNumber = '919217543325';
            const message = 'Hi, I am interested in a free sample.';
            const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
            window.open(url, '_blank');
          }}
        >
          <span className="free-sample-main">Get Free Sample</span>
          <span className="free-sample-sub">Only pay shipping charges</span>
        </button>
      </div>

      <div className="dropdowns-column">
        <Dropdown
          title="Spices and Dehydrated Powders"
          isOpen={true}
          products={products.filter((product) => product.category === 'Spices')}
          setSelectedProduct={setSelectedProduct}
          showMoreProductsCard={true}
          pdf={spicesDehydratedPdf}
          onContactUs={onContactUs}
        />

        <Dropdown
          title="Herbal Powders"
          isOpen={true}
          products={products.filter((product) => product.category === 'Herbal Powders')}
          setSelectedProduct={setSelectedProduct}
          showMoreProductsCard={true}
          pdf={herbalPdf}
          onContactUs={onContactUs}
        />

        <Dropdown
          title="Dry Fruits"
          isOpen={true}
          products={products.filter((product) => product.category === 'Dry Fruits')}
          setSelectedProduct={setSelectedProduct}
        />
      </div>

      <BuyModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />
    </>
  );
}

export default ProductsSection;
